import { Alert, AlertFooter, Button, Dialog, DialogContent } from '@bi-digital/react';
import { useTranslation } from 'react-i18next';
import { CrossIcon } from '@bi-digital/icons';

import styles from './ErrorDialog.module.css';

interface ErrorDialogProps {
    onClose: () => void;
    message: string;
    heading: string;
}

export default function ErrorDialog({ onClose, message, heading }: ErrorDialogProps) {
    const { t } = useTranslation();

    return (
        <Dialog open onClose={onClose}>
            <DialogContent className={styles.errorDialog}>
                <Alert data-color='info' className={styles.errorDialogMessage}>
                    <div>
                        <h2>{heading}</h2>
                        <p>{message}</p>
                    </div>

                    <AlertFooter>
                        <Button startIcon={<CrossIcon />} variant='text' onClick={() => onClose()}>
                            {t('common:close')}
                        </Button>
                    </AlertFooter>
                </Alert>
            </DialogContent>
        </Dialog>
    );
}
